import axios from "../../../util/axios";

export default {

    // 查询商户列表
    queryMerchantList: () => axios.get({url: '/basedata/plat/merchant/erp/queryMerchantList'}),

    // 查询erp往来单位列表
    queryErpMerchantList: (data) => axios.get({url: '/basedata/plat/merchant/erp/queryErpMerchantList', data}),

    // 绑定erp往来单位绑定
    saveErpMerchant: (data) => axios.post({url: '/basedata/plat/merchant/erp/saveErpMerchant', data}),

    // 修改erp往来单位绑定
    updateErpMerchant: (data) => axios.post({url: '/basedata/plat/merchant/erp/updateErpMerchant', data}),

    // 删除erp往来单位绑定
    deleteErpMerchant: (id) => axios.post({url: '/basedata/plat/merchant/erp/deleteErpMerchant', data:{id}}),

    // 查询列表
    queryList: (data) => axios.get({url: '/basedata/plat/merchant/erp/queryList', data}),
}